import React from 'react';
import { SyncProgress } from '../types';

interface SyncProgressBarProps {
  progress: SyncProgress | null | undefined;
  compact?: boolean;
}

const SyncProgressBar: React.FC<SyncProgressBarProps> = ({ progress, compact = false }) => {
  if (!progress || progress.total == null || progress.total <= 0) {
    return (
      <span className="text-sm text-gray-500">
        {compact ? 'Syncing…' : 'Syncing…'}
      </span>
    );
  }

  const percent = progress.percent ?? (progress.total > 0 ? Math.round((progress.processed / progress.total) * 1000) / 10 : 0);
  const pct = Math.min(100, Math.max(0, percent));

  if (compact) {
    return (
      <div className="flex items-center gap-2">
        <div className="w-16 h-1.5 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-primary-600 rounded-full transition-all duration-300"
            style={{ width: `${pct}%` }}
          />
        </div>
        <span className="text-xs text-gray-600 tabular-nums">{pct.toFixed(1)}%</span>
      </div>
    );
  }

  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between text-sm">
        <span className="text-gray-600">
          {progress.processed} / {progress.total} files
          {progress.synced > 0 && <span className="text-green-600 ml-1">({progress.synced} synced)</span>}
          {progress.skipped > 0 && <span className="text-gray-500 ml-1">({progress.skipped} skipped)</span>}
          {progress.errors > 0 && <span className="text-red-600 ml-1">({progress.errors} errors)</span>}
        </span>
        <span className="font-medium text-gray-700 tabular-nums">{pct.toFixed(1)}%</span>
      </div>
      <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full bg-primary-600 rounded-full transition-all duration-300"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
};

export default SyncProgressBar;
